import axios from "../../axios.js";
const sendNotification = async ({ commit }, data) => {
  if (data.group && data.group === 'selected_phone_numbers') {
    data.group = 'PHONE_NUMBERS'
  }
  const group = data.group ? `${data.group}`.toUpperCase() : ''
  const body = JSON.stringify({
    title: data.title,
    body: data.body,
    phone_numbers: data.phone_numbers,
    partners_ids: data.partners_ids,
    not_required_marketing_agreement: data.not_required_marketing_agreement,
    group
  });
  const config = {
    headers: {
      "Content-Type": "application/json"
    },
  };

  try {
    const res = await axios.post(`api/notification/admin`, body, config);
    if (data.photo) {
      const formData = new FormData();
      formData.append("file", data.photo, data.photo.name);
      await axios.post(
        `api/notification/photo?admin_notification_id=${res.data.notificationAdminId}`,
        formData,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "multipart/form-data",
          },
        }
      );

    }
    commit("SEND_NOTIFICATION_SUCCESS", {
      message: res.data.message,
      status: true,
    });
    return res;
  } catch (error) {
    commit("SEND_NOTIFICATION_FAIL", {
      message: "Błąd przy wysyłaniu powiadomienia",
      status: false,

    });

    return error;

  }
};
const getAllNotifications = ({ commit }) => {
  axios
    .get("api/notification/all")
    .then((res) => {
      commit("GET_NOTIFICATIONS_SUCCESS", res.data);
    })
    .catch((err) => {
      commit("GET_NOTIFICATIONS_FAIL", err.data);
    });
};

const fetchAllAdminNotifications = ({ commit }, data) => {
  const page_number =
    data && data.page_number !== null ? `page_number=${data.page_number}&` : "";
  const on_page = data && data.on_page !== null ? `on_page=${data.on_page}&` : "";
  axios
    .get(`api/notification/admin?${page_number}${on_page}`)
    .then((res) => {
      commit("SET_ADMIN_NOTIFICATIONS", res.data);
    })
};

const fetchAllGroupMessages = ({ commit }) => {
  axios
    .get(`api/groupMessage`)
    .then((res) => {
      commit("SET_GROUP_MESSAGES", res.data);
    })
};

export default {
  getAllNotifications,
  sendNotification,
  fetchAllAdminNotifications,
  fetchAllGroupMessages
};
